// @flow
import { asyncPaymentRedirectToOrderPage } from '../../duck';
import {endpoints, postPaymentExecuteApi} from '../../api';

import type { Node } from 'react';
import type { ImplementationType, PaymentImpl } from '../index';
import type { Order } from '../../../../../entities';
import type { RootState } from '../../../../index';
import type {BillingAddressReq, PaymentExecuteReq} from '../../api';

export default class KashioPayment implements PaymentImpl {
  type: ImplementationType = 'kashio';
  order: Order;
  dispatch: Function;
  // Custom kashio properties
  kashioWindow: any;

  setUpPayment(order: Order, dispatch: Function, rootState: RootState) {
    this.order = order;
    this.dispatch = dispatch;
  }

  generateCustomUI = (): Node => undefined;

  executeUIAction(billingAddress: BillingAddressReq, rootState: RootState) {
    const order = rootState.newOrder.checkoutStep.order;

    if (order.invoice.payment.method === 'MANUAL_SETTLEMENT' && order.invoice.detail.total === '0.00') {
      const paymentRequest: PaymentExecuteReq = {
        method: this.order.invoice.payment.method,
        type: this.order.invoice.payment.subtype,
        billingAddress: billingAddress,
      }
      
      postPaymentExecuteApi(paymentRequest, {
        route: endpoints.POST_PAYMENT_EXECUTE.replace(':paymentId', this.order.invoice.payment.id),
      }).toPromise().then(
        (order: Order) => {
          if (['AVAILABLE', 'AVAILABLE_FOR_COURIER'].includes(order.state)) {
            window.location.reload();
          }

          this.kashioWindow = window.open('', 'Pagar con Kashio', 'width=850,height=500');

          if (this.order.invoice.payment.paymentData.shopperRedirectUrl) {
            this.showPopUp(this.order.invoice.payment.paymentData.shopperRedirectUrl);
            this.dispatch(asyncPaymentRedirectToOrderPage(order));
          }   
        },
      ).catch(
        ({data}: {data: {message: string, name: string}}) => {
          console.log('Unsuccessful payment execution for Kashio!', error);
          if (data.name === 'InvalidStateError') {
            document.location.reload();
          }
        },
      )
    }else {
      this.kashioWindow = window.open('', 'Pagar con Kashio', 'width=850,height=500');

      if (this.order.invoice.payment.paymentData.shopperRedirectUrl) {
        this.showPopUp(this.order.invoice.payment.paymentData.shopperRedirectUrl);
        this.dispatch(asyncPaymentRedirectToOrderPage(order));
      }
    }
  };

  showPopUp = (data: string) => {
    this.kashioWindow = window.open('', 'Pagar con Kashio', 'width=850,height=500');
    this.kashioWindow.location = data;
    this.kashioWindow.focus();
  };

  clean = () => {
    if (this.kashioWindow) {
      this.kashioWindow.close();
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutStep/PaymentImpl/Kashio/index.js